<!--考试日历页-->
<template>
    <div id="calendar">
      <h1><router-link :to="{name: 'Index'}"></router-link>考试日历</h1>
      <nav>
        <router-link :to="{name: 'Calendar'}" class="bs">笔试</router-link>
        <router-link :to="{name: 'Calendar2'}" class="ms">面试</router-link>
      </nav>
      <!--倒计时-->
      <div id="djs">
        <h2>{{dataTitle}}</h2>
        <div class="day"><span v-for="(item, index) in timeNumber" :key="index">{{item}}</span> {{timeDay}}</div>
      </div>
      <!--报名阶段-->
      <!--
      <div class="section">
        <div class="title">
          <div class="out"><div class="in"></div></div>
          <h2>报名阶段</h2>
        </div>
        <ul class="main">
          <li>
            <b>报名时间：</b>
            9月3日起
          </li>
          <li>
            <b>报名公告：</b>
            考试报名公告
          </li>
          <li>
            <b>报名入口：</b>
            考试报名入口
          </li>
          <li>
            <a href="">新手指南</a>
            <a href="">报名条件解析</a>
          </li>
        </ul>
      </div>
      -->
      <!--考试阶段-->
      <!--
      <div class="section">
        <div class="title">
          <div class="out"><div class="in"></div></div>
          <h2>考试阶段</h2>
        </div>
        <ul class="main">
          <li>
            <b>打印时间：</b>
            9月3日起
          </li>
          <li>
            <b>考试时间：</b>
            11月2日
          </li>
          <li>
            <a href="">考试大纲</a>
            <a href="">考试科目</a>
          </li>
        </ul>
      </div>
      -->
      <!--查分阶段-->
      <!--
      <div class="section">
        <div class="title">
          <div class="out"><div class="in"></div></div>
          <h2>查分阶段</h2>
        </div>
        <ul class="main">
          <li>
            <b>查分时间：</b>
            预计2月上旬
          </li>
          <li>
            <b>考试时间：</b>
            成绩查询入口
          </li>
          <li>
            <a href="">一键查分</a>
            <a href="">合格分数线</a>
          </li>
        </ul>
      </div>
      -->
      <div class="section" v-for="(item, index) in dataInfo" :key="index">
        <div class="title">
          <div class="out"><div class="in"></div></div>
          <h2>{{item.type_name}}</h2>
        </div>
        <ul class="main">
          <li v-for="(item2, index2) in item.info.form" :key="index2">
            <b>{{item2.name}}：</b>
            <a @click="jumpUrl(item2.href, 11, 0)">{{item2.title}}</a>
          </li>
          <li>
            <a @click="jumpUrl(item3.href, 11, 0)" v-for="(item3, index3) in item.info.button" :key="index3">{{item3.title}}</a>
          </li>
        </ul>
      </div>
    </div>
</template>

<script>
export default {
  name: 'calendar',
  data () {
    return {
      dataInfo: {},
      dataTitle: '距离2024年考试还有',
      timeDay: '天',
      timeNumber: []
    }
  },
  mounted () {
    this.getCalendar()
  },
  methods: {
    getCalendar () {
      let data = {
        // id: this.$route.query.id ? this.$route.query.id : 5
        id: 5 // 只展示笔试日历
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_home_countdown_details',
        params: data,
        headers: {
          'sign': this.$encryption(data)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            this.dataInfo = res.data.data.data_info
            this.dataTitle = res.data.data.data_title
            this.timeDay = res.data.data.time_day
            this.timeNumber = res.data.data.time_number
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    back () {
      if (window.history.length <= 1) {
        this.router.push({path: '/'})
      } else {
        this.$router.go(-1)
      }
    },
    jumpUrl (classId, jumpType, signUp) {
      switch (jumpType) {
        case 0: // 0 不跳转
          event.preventDefault()
          break
        case 1: // 1 h5连接[资讯]
          this.$router.push(classId)
          break
        case 2: // 2 课程列表【合集id】 暂时用不到
          if (signUp) {
            this.$router.push({name: 'VideoPlay', query: {class_id: classId}})
          } else {
            this.$router.push({name: 'ClassDetailTeacher', query: {class_id: classId}})
          }
          break
        case 3: // 3 班级详情【班级id】
          if (signUp) {
            this.$router.push({name: 'VideoPlay', query: {class_id: classId}})
          } else {
            this.$router.push({name: 'ClassDetailTeacher', query: {class_id: classId}})
          }
          break
        case 4: // 4 h5连接[活动]
          this.$router.push(classId)
          break
        case 11:
          this.easyChat()
          break
      }
    },
    easyChat () {
      this.$easyliao(12523, 20523)
      return false
    }
  }
}
</script>

<style scoped lang="stylus">
  #calendar
    position: relative
    &::before
      content: ""
      position: absolute
      top: 3rem
      left: .34rem
      z-index: -1
      display: block
      width: .04rem
      height: 85%
      background-color: #F09C6E
    & > h1
      position: relative
      line-height: .8rem
      background-color: #fff
      padding: 0.14rem 0.16rem
      font-size: .4rem
      font-weight: 600
      text-align: center
      a
        position: absolute
        top: .14rem
        left: .16rem
        display: block
        width: .8rem
        height: .8rem
        background-color: #fff
        -webkit-border-radius: 50%
        -moz-border-radius: 50%
        border-radius: 50%
        &::before
          content: ""
          position: absolute
          top: .3rem
          left: .32rem
          display: block
          width: .20rem
          height: .20rem
          border-left: .03rem solid #050505
          border-bottom: .03rem solid #050505
          -webkit-transform: rotate(45deg)
          -moz-transform: rotate(45deg)
          -ms-transform: rotate(45deg)
          -o-transform: rotate(45deg)
          transform: rotate(45deg)
    nav
      display: flex
      justify-content: space-between
      align-items: center
      width: 6.7rem
      height: .88rem
      margin: 0 auto
      a
        display: block
        width: 3.34rem
        height: .88rem
        line-height: .88rem
        background: linear-gradient(270deg,rgba(249,103,72,1) 0%,rgba(227,52,42,1) 100%)
        font-size: .32rem
        color: #fff
        text-align: center
        border-radius: 2rem 0rem 0rem 2rem
        &:last-child
          background: linear-gradient(270deg,rgba(60,145,242,1) 0%,rgba(30,129,242,1) 100%)
          border-radius: 0rem 2rem 2rem 0rem
    #djs
      display: flex
      justify-content: space-between
      align-items: center
      width: 7.1rem
      height: 1rem
      background-color: #F4F4F4
      margin: .4rem auto 0
      font-size: .28rem
      color: #333
      -webkit-border-radius: .2rem
      -moz-border-radius: .2rem
      border-radius: .2rem
      h2
        line-height: 1rem
        padding-left: .7rem
        background: url(../../assets/icon/home_icon_time.png) no-repeat .24rem center
        -webkit-background-size: .32rem
        background-size: .32rem
        -webkit-box-sizing: border-box
        -moz-box-sizing: border-box
        box-sizing: border-box
      div.day
        line-height: 1rem
        padding-right: .3rem
        span
          display: inline-block
          width: .36rem
          height: .42rem
          line-height: .42rem
          vertical-align: middle
          background: url(../../assets/icon/home_icon_djs.png) no-repeat center
          margin-right: .1rem
          -webkit-background-size: 100%
          background-size: 100%
          color: #fff
          text-align: center
    .section
      margin-top: .42rem
      .title
        display: flex
        justify-content: left
        align-items: center
        width: 2.72rem
        height: .7rem
        background: linear-gradient(to right, #F9693D, #E5422B)
        -webkit-border-radius: .35rem
        -moz-border-radius: .35rem
        border-radius: .35rem
        h2
          flex: 1
          line-height: .7rem
          font-size: .32rem
          color: #fff
          text-align: center
        .out
          display: flex
          justify-content: center
          align-items: center
          flex: 0 0 auto
          width: .68rem
          height: .68rem
          border: .01rem solid #F9693D
          background-color: #fff
          -webkit-border-radius: 50%
          -moz-border-radius: 50%
          border-radius: 50%
          .in
            display: block
            width: .34rem
            height: .34rem
            background: linear-gradient(to right, #F4B268, #FD673C)
            -webkit-border-radius: 50%
            -moz-border-radius: 50%
            border-radius: 50%
      ul.main
        display: block
        width: 6.64rem
        padding: .04rem .24rem .16rem
        margin: .28rem .28rem 0 .58rem
        -webkit-box-sizing: border-box
        -moz-box-sizing: border-box
        box-sizing: border-box
        -webkit-border-radius: .16rem
        -moz-border-radius: .16rem
        border-radius: .16rem
        -webkit-box-shadow: 0 0 .12rem 0 rgba(231,232,233,1)
        -moz-box-shadow: 0 0 .12rem 0 rgba(231,232,233,1)
        box-shadow: 0 0 .12rem 0 rgba(231,232,233,1)
        li
          height: .86rem
          line-height: .86rem
          border-bottom: .02rem solid #E7E8E9
          font-size: .28rem
          color: #666
          b
            font-size: .28rem
            font-weight: normal
            color: #9DA4B3
          &:last-child
            display: flex
            justify-content: space-around
            align-items: center
            height: 1.24rem
            border: none
            a
              display: block
              width: 2.68rem
              height: .78rem
              line-height: .74rem
              border:0.02rem solid rgba(255,112,82,1);
              color: #FF7052
              -webkit-box-sizing: border-box
              -moz-box-sizing: border-box
              box-sizing: border-box
              // box-shadow:0rem 0.04rem 0.08rem 0rem rgba(255,112,82,0.48)
              border-radius:0.39rem
              text-align: center
</style>



// WEBPACK FOOTER //
// src/components/single/calendar.vue